import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import gif from '../../../../images/Profile/about-unscreen.gif'

const About = () => {
    return (
        <div className=' text-white text-start my-5' id="about">
            <Container>
                <div>
                    <h1>About Me</h1>
                    <h5 style={{ color: 'red' }}>Who i am</h5>
                </div>
                <Row className='mt-5'>
                    <Col md={6}>
                        <img src={gif} className='img-fluid rounded' alt="" />

                    </Col>
                    <Col md={6} className="fs-5">
                        <p >Hello! My name is <span style={{ color: 'red' }}>Md Zahid Hasan</span>  - a junior front-end developer specializing in building React.js WebApp. I enjoy creating things that live on the internet. My interest in web development started back in 2021, I use Javascript and React.js to create high-end interactive experiences and products.</p>
                        <br />
                        <p>Skilled in Html5,Css3,Bootstrap,Tailwind,Material UI, JavaScript, ES6, React JS, React Router, Firebase. Express, Mongodb, Node js, Heroku
                            I have some experience efficiently coding websites and applications using modern HTML, CSS, JavaScript, and react. Also using other modern technologies easy-to-use, user-friendly websites and applications are a passion of mine and I am assured I might be a wonderful addition to your organization.</p>
                    </Col>
                </Row>
            </Container >
        </div >
    );
};

export default About;